/**
 * mosaic-grid — fill columns left to right in settings order.
 * Each column holds `rows` slots. Large = 2, Medium/Small = 1.
 * Tiles that do not fit (and everything after) are hidden.
 * Assigned L/M/S heights are kept.
 */
class MosaicGrid extends HTMLElement {
  connectedCallback() {
    this.desktop = this.querySelector('[data-mosaic-desktop]');
    if (!this.desktop) return;

    this.columns = Math.max(1, parseInt(this.dataset.columns || '4', 10));
    this.rows = Math.max(1, parseInt(this.dataset.rows || '3', 10));
    this.mq = window.matchMedia('(min-width: 769px)');
    this.onBreakpoint = () => this.layout();
    this.mq.addEventListener('change', this.onBreakpoint);

    this.layout();

    if (window.Shopify?.designMode) {
      this.onSectionLoad = (event) => {
        if (event.target.contains(this) || event.target === this) this.layout();
      };
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      document.addEventListener('shopify:section:reorder', this.onSectionLoad);
    }
  }

  disconnectedCallback() {
    this.mq?.removeEventListener('change', this.onBreakpoint);
    if (this.onSectionLoad) {
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      document.removeEventListener('shopify:section:reorder', this.onSectionLoad);
    }
  }

  slotCost(tile) {
    return tile.dataset.height === 'large' ? 2 : 1;
  }

  layout() {
    if (!this.desktop) return;

    this.unwrap();
    this.desktop.querySelectorAll('[data-mosaic-tile]').forEach((tile) => {
      tile.hidden = false;
    });

    if (!this.mq.matches) {
      this.desktop.removeAttribute('data-packed');
      // this.markIndexes();
      return;
    }

    const tiles = [...this.desktop.querySelectorAll('[data-mosaic-tile]')];
    if (tiles.length === 0) {
      this.desktop.removeAttribute('data-packed');
      return;
    }

    const colCount = this.columns;
    const rows = this.rows;

    this.desktop.style.setProperty('--mg-columns', String(colCount));
    this.desktop.style.setProperty('--mg-rows', String(rows));

    const cols = [];
    for (let i = 0; i < colCount; i += 1) {
      const el = document.createElement('div');
      el.className = 'mosaic-grid__col';
      el.setAttribute('data-mosaic-col', '');
      cols.push({ el, slots: 0 });
    }

    let c = 0;
    let hideRest = false;
    tiles.forEach((tile) => {
      if (hideRest) {
        tile.hidden = true;
        return;
      }

      const cost = this.slotCost(tile);
      while (c < colCount && cols[c].slots + cost > rows) {
        if (cols[c].slots === 0) break;
        c += 1;
      }

      if (c >= colCount || cols[c].slots + cost > rows) {
        hideRest = true;
        tile.hidden = true;
        return;
      }

      cols[c].el.appendChild(tile);
      cols[c].slots += cost;
    });

    cols.forEach((col) => {
      if (col.slots > 0) this.desktop.appendChild(col.el);
    });

    this.desktop.setAttribute('data-packed', '');
    // this.markIndexes();
  }

  /*
  markIndexes() {
    const tiles = this.desktop
      ? [...this.desktop.querySelectorAll('[data-mosaic-tile]')]
      : [];

    tiles.forEach((tile) => {
      const index = tile.dataset.settingIndex || '';
      tile.dataset.mosaicIndex = index;
      const label = tile.querySelector('[data-mosaic-index]');
      if (label) label.textContent = index;
    });
  }
  */

  unwrap() {
    this.desktop.querySelectorAll('[data-mosaic-col]').forEach((col) => {
      while (col.firstChild) {
        this.desktop.insertBefore(col.firstChild, col);
      }
      col.remove();
    });
  }
}

if (!customElements.get('mosaic-grid')) {
  customElements.define('mosaic-grid', MosaicGrid);
}
